<div class="bd_login memver_login">
    <div class="container-fluid pl-0 pr-0">
        <div class="row no-gutters">
            <div class="col-md-6">
                <div class="bd_loginimg bdloginimg">
                    <img src="assets/img/img3.jpg" class="login_bg">
                    <div class="bd_loginlogo">
                        <a routerLink="/"><img src="assets/img/logo.png"></a>
                        <div class="bd_logintext">
                            <!-- <h2>E-Trade Platform For <br> Private Sales And Procurement</h2> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 d-flex align-items-center">
                <div class="bd_loginbox bd_memberbox">
                    <h3>Sign Up</h3>
                    <p>Enter your details below.</p>

                    <form [formGroup]="registerForm">
                        <div class="row">
                            <div class="form-group col-sm-6">
                                <ng-select [items]="roleMaster" bindLabel="label" bindValue="value" formControlName="role" placeholder="Select Role" [class.is-invalid]="( !Global.isInputValid(registerForm, 'role') )"></ng-select>

                                <div class="invalid-feedback" *ngIf="!Global.isInputRuleValid(registerForm, 'role', 'required')">
                                    <div>This field is required</div>
                                </div>
                            </div>

                            <div class="form-group col-sm-6">
                                <input type="text" appArrowNavigation formControlName="name" placeholder="Name" [class.is-invalid]="( !Global.isInputValid(registerForm, 'name') )" class="form-control">

                                <div class="invalid-feedback" *ngIf="!Global.isInputRuleValid(registerForm, 'name', 'required')">
                                    <div>This field is required</div>
                                </div>
                            </div>

                            <div class="form-group col-sm-6">
                                <input type="text" appArrowNavigation formControlName="email" placeholder="Email" [class.is-invalid]="( !Global.isInputValid(registerForm, 'email') )" class="form-control">

                                <div class="invalid-feedback" *ngIf="!Global.isInputRuleValid(registerForm, 'email', 'required')">
                                    <div>This field is required</div>
                                </div>

                                <div class="invalid-feedback" *ngIf="!Global.isInputRuleValid(registerForm, 'email', 'email')">
                                    <div>Please enter valid email</div>
                                </div>
                            </div>

                            <div class="form-group col-sm-6">
                                <input type="text" appArrowNavigation formControlName="mobile" placeholder="Mobile" [class.is-invalid]="( !Global.isInputValid(registerForm, 'mobile') )" class="form-control">

                                <div class="invalid-feedback" *ngIf="!Global.isInputRuleValid(registerForm, 'mobile', 'required')">
                                    <div>This field is required</div>
                                </div>

                                <div class="invalid-feedback" *ngIf="(!Global.isInputRuleValid(registerForm, 'mobile', 'pattern') || !Global.isInputRuleValid(registerForm, 'mobile', 'minlength') || !Global.isInputRuleValid(registerForm, 'mobile', 'maxlength'))">
                                    <div>Please enter valid mobile number</div>
                                </div>
                            </div>

                            <div class="form-group col-sm-6">
                                <input type="password" appArrowNavigation formControlName="password" placeholder="Password" [class.is-invalid]="( !Global.isInputValid(registerForm, 'password') )" class="form-control" autocomplete="new-password">

                                <div class="invalid-feedback" *ngIf="!Global.isInputRuleValid(registerForm, 'password', 'required')">
                                    <div>This field is required</div>
                                </div>

                                <div class="invalid-feedback" *ngIf="!Global.isInputRuleValid(registerForm, 'password', 'minlength')">
                                    <div>The password must be minimum 6 characters</div>
                                </div>

                                <div class="invalid-feedback" *ngIf="!Global.isInputRuleValid(registerForm, 'password', 'maxlength')">
                                    <div>The password must be maximum 20 characters</div>
                                </div>
                            </div>

                            <div class="form-group col-sm-6">
                                <input type="password" appArrowNavigation formControlName="password_confirmation" placeholder="Re-enter Password" [class.is-invalid]="( !Global.isInputValid(registerForm, 'password_confirmation') )" class="form-control">

                                <div class="invalid-feedback" *ngIf="!Global.isInputRuleValid(registerForm, 'password_confirmation', 'required')">
                                    <div>This field is required</div>
                                </div>
                                
                                <div class="invalid-feedback" *ngIf="!Global.isInputRuleValid(registerForm, 'password_confirmation', 'minlength')">
                                    <div>The password must be minimum 6 characters</div>
                                </div>
                                
                                <div class="invalid-feedback" *ngIf="!Global.isInputRuleValid(registerForm, 'password_confirmation', 'maxlength')">
                                    <div>The password must be maximum 20 characters</div>
                                </div>

                                <div class="invalid-feedback" *ngIf="!Global.isInputRuleValid(registerForm, 'password_confirmation', 'passwordConfirmation')">
                                    <div>The password confirmation didn't matched</div>
                                </div>
                            </div>

                            <ng-container formGroupName="company_info">
                                <div class="form-group col-sm-6">
                                    <input type="text" appArrowNavigation formControlName="company_name" placeholder="Company Name" [class.is-invalid]="( !Global.isInputValid(registerForm, 'company_info.company_name') )" class="form-control">
    
                                    <div class="invalid-feedback" *ngIf="!Global.isInputRuleValid(registerForm, 'company_info.company_name', 'required')">
                                        <div>This field is required</div>
                                    </div>
                                </div>

                                <div class="form-group col-sm-6">
                                    <input type="text" appArrowNavigation formControlName="company_phone" placeholder="Company Phone" [class.is-invalid]="( !Global.isInputValid(registerForm, 'company_info.company_phone') )" class="form-control">
    
                                    <div class="invalid-feedback" *ngIf="!Global.isInputRuleValid(registerForm, 'company_info.company_phone', 'required')">
                                        <div>This field is required</div>
                                    </div>

                                    <div class="invalid-feedback" *ngIf="(!Global.isInputRuleValid(registerForm, 'company_info.company_phone', 'pattern') || !Global.isInputRuleValid(registerForm, 'company_info.company_phone', 'minlength') || !Global.isInputRuleValid(registerForm, 'company_info.company_phone', 'maxlength'))">
                                        <div>Please enter valid phone number</div>
                                    </div>
                                </div>

                                <div class="form-group col-sm-6">
                                    <input type="text" appArrowNavigation formControlName="company_address" placeholder="Company Address" [class.is-invalid]="( !Global.isInputValid(registerForm, 'company_info.company_address') )" class="form-control">
    
                                    <div class="invalid-feedback" *ngIf="!Global.isInputRuleValid(registerForm, 'company_info.company_address', 'required')">
                                        <div>This field is required</div>
                                    </div>
                                </div>

                                <div class="form-group col-sm-6">
                                    <input type="text" appArrowNavigation formControlName="company_pincode" placeholder="Company Pincode" [class.is-invalid]="( !Global.isInputValid(registerForm, 'company_info.company_pincode') )" class="form-control">
    
                                    <div class="invalid-feedback" *ngIf="!Global.isInputRuleValid(registerForm, 'company_info.company_pincode', 'required')">
                                        <div>This field is required</div>
                                    </div>

                                    <div class="invalid-feedback" *ngIf="(!Global.isInputRuleValid(registerForm, 'company_info.company_pincode', 'pattern') || !Global.isInputRuleValid(registerForm, 'company_info.company_pincode', 'minlength') || !Global.isInputRuleValid(registerForm, 'company_info.company_pincode', 'maxlength'))">
                                        <div>Please enter valid pincode</div>
                                    </div>
                                </div>

                                <div class="form-group col-sm-6">
                                    <input type="text" appArrowNavigation formControlName="company_pan_no" placeholder="Company PAN No" [class.is-invalid]="( !Global.isInputValid(registerForm, 'company_info.company_pan_no') )" class="form-control">
    
                                    <div class="invalid-feedback" *ngIf="!Global.isInputRuleValid(registerForm, 'company_info.company_pan_no', 'required')">
                                        <div>This field is required</div>
                                    </div>

                                    <div class="invalid-feedback" *ngIf="!Global.isInputRuleValid(registerForm, 'company_info.company_pan_no', 'pattern')">
                                        <div>Please enter valid PAN Number</div>
                                    </div>
                                </div>

                                <div class="form-group col-sm-6">
                                    <input type="text" appArrowNavigation formControlName="company_gst_no" placeholder="Company GST No" [class.is-invalid]="( !Global.isInputValid(registerForm, 'company_info.company_gst_no') )" class="form-control">
    
                                    <div class="invalid-feedback" *ngIf="!Global.isInputRuleValid(registerForm, 'company_info.company_gst_no', 'required')">
                                        <div>This field is required</div>
                                    </div>

                                    <div class="invalid-feedback" *ngIf="!Global.isInputRuleValid(registerForm, 'company_info.company_gst_no', 'pattern')">
                                        <div>Please enter valid GST Number</div>
                                    </div>
                                </div>
                            </ng-container>

                            <div class="col-12 mb-3">
                                <label for="accept_terms">
                                    <input type="checkbox" formControlName="accept_terms" id="accept_terms" [class.is-invalid]="( !Global.isInputValid(registerForm, 'accept_terms') )"/>
                                    I accept <a target="_blank" routerLink="/terms-conditions">Terms & Conditions</a>
                                </label>
                            </div>

                            <div class="col-12 text-right">
                                <button type="submit" class="btn" (click)="submit($event)">
                                    <span class="indicator-label">SignUp</span>
                                    <span class="indicator-progress">Please wait...
                                        <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                    </span>
                                </button>
                            </div>
                            
                            <div class="col-12 bd_signtext mt-4">
                                Already have an account? <a routerLink="/login">Login</a>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>